module.exports = __webpack_public_path__ + "static/media/sns.198d762a.png";